<template>
    <div>
      <v-row justify="center" class="pb-16">
        <v-col cols="12">
          <v-row justify="center" class="pt-16">
            <v-col cols="12" class="text-center hed">
              <span>NEWS & EVENTS</span>
            </v-col>
            <v-col cols="5" sm="2" md="2" lg="1" class="pa-0 px-3 text-center">
                <v-progress-linear color="yellow darken-2" model-value="100"></v-progress-linear>
              </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="10" class="text-right">
              <v-btn icon size="small" @click="prevSlide">
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
              <v-btn icon size="small" @click="nextSlide">
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </v-col>
          </v-row>
  
          <v-row justify="center">
            <v-col cols="10" style="background-color: #F8F8F8;">
              <v-carousel v-model="currentIndex" cycle hide-delimiters class="custom-carousel" :show-arrows="false" height="auto">
                <v-carousel-item v-for="(item, index) in allCarouselItems" :key="index">
                  <v-row justify="center" class="pa-5">
                    <v-col cols="12" sm="6" md="3" lg="3">
                      <v-img :src="item[0].image"></v-img>
                    </v-col>
                    <v-col cols="12" sm="6" md="3" lg="3">
                      <div>{{ item[0].text }}</div>
                    </v-col>
                    <v-col cols="12" sm="6" md="3" lg="3">
                      <v-img :src="item[1].image"></v-img>
                    </v-col>
                    <v-col cols="12" sm="6" md="3" lg="3">
                      <div>{{ item[1].text }}</div>
                    </v-col>
                  </v-row>
                </v-carousel-item>
              </v-carousel>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <!-- <v-row justify="center" class="pb-16">
        <v-col cols="12" align-self="center" class="text-center">
          <v-btn color="red" @click="viewMore">View More</v-btn>
        </v-col>
      </v-row> -->
    </div>
  </template>
  
  <script>
import axios from "axios";
  
  export default {
    data() {
      return {
        currentIndex: 0,
        allCarouselItems: [
          [
            { image: require("../../assets/images/news1.png"), text: "Lorem ipsum dolor sit amet consectetur. Volutpat adipiscing nibh tortor nulla. Iaculis fermentum euismod arcu dignissim at euismod. Neque tellus " },
            { image: require("../../assets/images/news2.png"), text: "Lorem ipsum dolor sit amet consectetur. Volutpat adipiscing nibh tortor nulla. Iaculis fermentum euismod arcu dignissim at euismod. Neque tellus " },
          ],
          [
            { image: require("../../assets/images/news1.png"), text: "Lorem ipsum dolor sit amet consectetur. Volutpat adipiscing nibh tortor nulla. Iaculis fermentum euismod arcu dignissim at euismod. Neque tellus " },
            { image: require("../../assets/images/news2.png"), text: "Lorem ipsum dolor sit amet consectetur. Volutpat adipiscing nibh tortor nulla. Iaculis fermentum euismod arcu dignissim at euismod. Neque tellus " },
          ],
        ],
      };
    },
    methods: {
      getData() {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/notice/list",
        // headers: {
          
        // },
        // params:{
          
        // }
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.alertList = response.data.data;
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          
          console.log(err);
        });
    },
      nextSlide() {
        console.log("Next slide");
        this.currentIndex = (this.currentIndex + 1) % this.allCarouselItems.length;
      },
      prevSlide() {
        console.log("Previous slide");
        this.currentIndex = (this.currentIndex - 1 + this.allCarouselItems.length) % this.allCarouselItems.length;
      },
      viewMore() {
        // console.log("View more clicked");
      },
    },
    mounted() {
    this.getData();
  },
  };
  </script>
  
  <style>
  .hed {
    font-family: interregular;
    font-weight: 700;
    font-size: 22px;
    color: #3C74B9;
  }
  
  .custom-carousel .v-carousel-controls {
    display: none !important;
  }
  </style>
  